import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration with better defaults
 * and error handling for the inspector portal
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Don't refetch when user switches tabs/windows
      refetchOnWindowFocus: false,

      // Don't refetch when component remounts
      refetchOnMount: true,

      // Don't refetch when network reconnects unless data is stale
      refetchOnReconnect: 'always',

      // Consider data stale after 5 minutes
      staleTime: 5 * 60 * 1000,

      // Keep unused data in cache for 10 minutes
      gcTime: 10 * 60 * 1000,

      // Retry failed requests 3 times with exponential backoff
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors (client errors)
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        // Retry up to 3 times for network/server errors
        return failureCount < 3;
      },

      // Exponential backoff delay
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      // Global error handler
      onError: (error) => {
        console.error('Query error:', error);
        // Additional error logging can be added here
      },
    },
    mutations: {
      // Global mutation error handler
      onError: (error) => {
        console.error('Mutation error:', error);
        // Additional error logging can be added here
      },
    },
  },
});
